module.exports = __webpack_public_path__ + "img/no-data.7c5a60db.png";